'use client';

import Hero from '../components/Hero';
import { AnimatePresence, m } from 'framer-motion';
import dynamic from 'next/dynamic';
import LazySection from '@/components/ui/LazySection';

// Lazy load heavy components
const Features = dynamic(() => import('../components/Features'), { ssr: true })
const SvgSection = dynamic(() => import('@/components/SvgSection'), { ssr: false })
const SmartPaymentPromo = dynamic(() => import('../components/SmartPaymentPromo'), { ssr: false })
const CardStudy = dynamic(() => import('../components/CardStudy'), { ssr: false })
const StickyScrollRevealDemo = dynamic(() => import('@/components/Sticky'), { ssr: false })
const Discover = dynamic(() => import('../components/Discover'), { ssr: false })
const PaymentHubServices = dynamic(() => import('@/components/PaymentHubServices'), { ssr: false })
const TechnologyStack = dynamic(() => import('@/components/TechnologyStack'), { ssr: false })
const Faqs = dynamic(() => import('../components/Testimonials'), { ssr: false })
const ROICalculator = dynamic(() => import('../components/ROICalculator'), { ssr: false })
const DeveloperAPI = dynamic(() => import('../components/DeveloperAPI'), { ssr: false })

export default function Home() {
  return (
    <div className="relative min-h-screen overflow-hidden transition-colors duration-300">
      <AnimatePresence mode="wait">
        <m.main
          key="theme"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.3 }}
          className="relative w-full overflow-x-hidden"
        >
          <Hero />
          <Features />

          <LazySection height="min-h-[300px] md:min-h-[400px]">
            <SvgSection />
          </LazySection>

          <LazySection height="min-h-[400px] md:min-h-[500px]">
            <SmartPaymentPromo />
          </LazySection>

          {/* <LazySection height="min-h-[500px] md:min-h-[600px]">
            <CardStudy />
          </LazySection> */}

          <LazySection height="min-h-[400px] md:min-h-[500px]">
            <StickyScrollRevealDemo />
          </LazySection>

          <LazySection height="min-h-[500px] md:min-h-[600px]">
            <Discover />
          </LazySection>

          <LazySection height="min-h-[400px] md:min-h-[500px]">
            <PaymentHubServices />
          </LazySection>

          <LazySection height="min-h-[300px] md:min-h-[400px]">
            <TechnologyStack />
          </LazySection>

          <LazySection height="min-h-[400px] md:min-h-[500px]">
            <Faqs />
          </LazySection>
        </m.main>
      </AnimatePresence>
    </div>
  );
}
